import { formatToIsoDay } from '@spa/utils/date'
import moment from 'moment'

/**
 * Return a list of ISO days contained in the current time range
 */
export const getIsoDaysInWeek = (date?: string) => {
  const isoDaysArr: string[] = []
  if (date) {
    const week = {
      start: moment(date).startOf('isoWeek'),
      end: moment(date).endOf('isoWeek')
    }
    const currentDate = moment(week.start).startOf('isoWeek')

    while (currentDate.isSameOrBefore(week.end)) {
      isoDaysArr.push(formatToIsoDay(currentDate))
      currentDate.add(1, 'day')
    }
  }

  return isoDaysArr
}
